import moment from 'moment-timezone';
import store from 'store';
import { OpsTask, OpsTaskInput, OpsTaskListResult, OpsTasksCounts, OpsTaskStatusId } from 'model/OpsTask';
import { OpsTaskDto, OpsTaskListDto, OpsTasksCountsDto } from './OpsTasksDto';

const marketplaceTimeZone = (): string => store.getState().marketplace.marketplace.schedule.timeZone;

export const convertOpsTask = (dto: OpsTaskDto): OpsTask => {
    const timeZone = marketplaceTimeZone();

    return {
        id: dto.id,
        description: dto.description,
        dueAt: moment(dto.due_at).tz(timeZone),
        status: dto.status as OpsTaskStatusId,
        statusName: dto.status_name,
        statusKey: dto.current_status,
        pastDue: dto.past_due,
        staff: (dto.staff ?? []).map(s => ({ id: s.id, name: s.name })),
        // The list item omits *_ids → derive from the staff/rooms objects; create/update responses send them directly.
        staffIds: dto.staff_ids ?? (dto.staff ?? []).map(s => s.id),
        rooms: (dto.rooms ?? []).map(r => ({ id: r.id, name: r.name })),
        roomIds: dto.room_ids ?? (dto.rooms ?? []).map(r => r.id),
        marketplaceId: dto.marketplace_id
    };
};

export const convertOpsTaskList = (dto: OpsTaskListDto): OpsTaskListResult => ({
    tasks: (dto.data ?? []).map(convertOpsTask),
    page: dto.page,
    size: dto.size,
    totalPages: dto.total_pages,
    totalRecords: dto.total_records
});

export const convertOpsTasksCounts = (dto: OpsTasksCountsDto): OpsTasksCounts => ({
    todo: dto.to_do,
    inProgress: dto.in_progress,
    pastDue: dto.past_due,
    completed: dto.completed,
    all: dto.all
});

// Builds the create/update request body. The backend expects the full staff/room lists on update.
export const toRequest = (input: OpsTaskInput): { ops_task: Record<string, unknown> } => ({
    ops_task: {
        description: input.description,
        due_at: input.dueAt.toISOString(),
        staff_ids: input.staffIds,
        room_ids: input.roomIds,
        ...(input.status !== undefined && { status: input.status })
    }
});
